import { Injectable } from "@angular/core";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { UserPreference } from "../../models/UserPreference";
import { appSettings, errorMessages } from "../../settings";
import * as moment from "moment";


@Injectable()
export class ReturnsavailabilityService {

  constructor(
    private _analyticsService: AnalyticsService,
    private _commonService: CommonService
  ) { }

  chartOptions() {
    return {
      tooltip: {
        formatter: "{b} : {c}%"
      },
      title: {
        text: "",
        textStyle: {
          color: "#fff",
          fontSize : 13,
          fontWeight: 'lighter'
        },
        bottom: '2%'
      },
      series: [
        {
          name: '% of Active Filled',
          title: {
            color: '#fff',
            show: true,
            offsetCenter: ['0', '100%']
          },
          type: 'gauge',
          detail: {
            formatter: '{value}%',
            fontSize: 15
          },
          radius: '60%',
          center: ['30%', '45%'],
          data: []
        },
        {
          name: '% Returns Locations Occupied',
          title: {
            color: '#fff',
            show: true,
            offsetCenter: ['0', '100%']
          },
          type: 'gauge',
          detail: {
            formatter: '{value}%',
            fontSize: 15
          },
          radius: '60%',
          center: ['70%', '45%'],
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log('ReturnsAvailabilityService')
    widget.dataLoaded = false;
    widget.Title = 'Returns Location Availability';
    let userPref: UserPreference = this._commonService.getUserPreference();
    console.time('getMHCurrentInventory-returns');
    this._analyticsService.getMHCurrentInventory(userPref.FacilityId, userPref.CustomerId)
      .subscribe((result: any) => {
        console.timeEnd('getMHCurrentInventory-returns');
        console.log('getMHCurrentInventory', result);
        let Series1: Array<any> = [];
        widget.chartOptions = this.chartOptions();
        widget.errorMessage = null;
        if (result && result.length > 0) {
          widget.dataLoaded = false;

          widget.chartOptions.series[0].data.push(
            { value: result[0].ACTIVE_FILLED_PCT.toFixed(2), name: '% of Active Filled' }
          )
          let returnsLocationsOccupied: number = 0;
          if (result[0].OCC_RETURN_LOCATION_COUNT > 0 && result[0].RETURN_LOCATION_COUNT > 0) {
            returnsLocationsOccupied = result[0].OCC_RETURN_LOCATION_COUNT / result[0].RETURN_LOCATION_COUNT;
          }
          widget.chartOptions.series[1].data.push(
            { value: returnsLocationsOccupied.toFixed(2), name: '% Returns Locations Occupied' }
          )

          widget.chartOptions.title.text = 'Returns Locations Available : ' + result[0].RETURN_LOCATION_COUNT + ' \n' 
          + 'Returns Locations Occupied : ' + result[0].OCC_RETURN_LOCATION_COUNT + '\n'
          + 'Open Active Locations : ' + result[0].OPEN_ACT_LOCATION_COUNT;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        //console.log(JSON.stringify(widget.chartOptions));
        widget.dataLoaded = true;
      }
        , err => {
          console.timeEnd('getMHCurrentInventory-returns');
          console.log('getMHCurrentInventory', err);
          widget.dataLoaded = true;
          widget.errorMessage = errorMessages.apiError;
        }
      );
  }

  reload(widget: any) { }

  remove(widget: any) { }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/returnsavailability.service.ts